import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicSharedModule } from '../../../ionic-shared.module';
import { AuthService } from '../../../services/auth.service';
import { DateUtilsService } from '../../../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { LoadingController, AlertController, NavController, IonModal, ModalController, IonPopover, IonInput } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { environment } from './../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxCroppedEvent } from '../../../component/ngx-photo-editor/ngx-photo-editor.component';
import { DataURIToBlob, blobToBase64 } from '../../../utils'
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { Animal, AnimalWeight, AnimalTag } from '../../../models/animal';
import { AgendaEvent, AgendaEventReport } from '../../../models/agenda';
import { NetworkService } from '../../../services/network.service';
import { AnimalService } from '../../../services/animal.service';
import { AgendaService } from '../../../services/agenda.service';
import { AnyObject } from 'chart.js/dist/types/basic';
import { FileCameraComponent } from '../../../component/file-camera/file-camera.component';
import Quill from 'quill';
import Delta from 'quill-delta';
import { QuillModule } from 'ngx-quill';
import { ComptaService } from 'src/app/services/compta.service';
import { addDays, addHours, addMinutes, addWeeks, addMonths, addYears } from 'date-fns';
import { CapacitorCalendar } from '@ebarooni/capacitor-calendar';
import { FastTreatmentConfig, getFastTreatments } from '../../../config/fast-treatments.config';

@Component({
  selector: 'event-fiche',
  templateUrl: './event-fiche.component.html',
  styleUrls: ['./event-fiche.component.scss'],
  imports: [IonicSharedModule],
})
export class EventFicheComponent  implements OnInit {
  @ViewChild('modalDisplayDocument', { static: false }) modalDisplayDocument!: IonModal;

  @Input() event: AgendaEvent | null = null;
  @Output() closeEvent = new EventEmitter<any>();

  environment = environment;
  loading: HTMLIonLoadingElement | null = null;
  modalDisplayDocumentDocument: { [key: string]: any } | null = null;
  modalDisplayDocumentDocumentBase64: string | null = null
  now: Date = new Date()
  fastTreatments: FastTreatmentConfig[] = [];
  
  // Next occurrence modal
  isNextOccurrenceModalOpen: boolean = false;
  nextOccurrenceMessage: string = '';
  nextOccurrenceDuration: number = 0;
  nextOccurrenceUnit: string = 'Days';

  constructor(
    private http: HttpClient,
    public dateUtils: DateUtilsService,
    private authService: AuthService,
    private navCtrl: NavController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public fb: FormBuilder,
    public alertController: AlertController,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    public networkService: NetworkService,
    public agendaService: AgendaService,
    public animalService: AnimalService,
    public modalController: ModalController,
    public router: Router,
    public comptaService: ComptaService) { 
      this.fastTreatments = getFastTreatments(this.translate);
    }

  ngOnInit() {}

  async presentLoading(label = null) {
    if(this.loading)
      this.stopLoading();

    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: label ? label: this.translate.instant('Please wait...'),
      duration: 60000
    });
    await this.loading.present();
  }

  stopLoading() {
    this.loading?.dismiss();
    this.loading = null;
  }

  async setModalDisplayDocumentDocument(document: { [key: string]: any }) {
    this.modalDisplayDocumentDocument = document;
    if(document['fileName'].toLowerCase().endsWith('.pdf')) {
      this.modalDisplayDocumentDocumentBase64 = null

      var headers = new HttpHeaders({
        'content-type': 'application/json'
      });
      var formData = {
        'type': document['base64'] ? 'base64': 'url',
        'base64': document['base64'],
        'url': document['file'],
      }
      await this.presentLoading();
      this.http.post(environment.API_URL + '../ws_public/getImageBase64FromPDF/', JSON.stringify(formData), {headers : headers}).subscribe(async (data: { [key: string]: any }) => { 
          this.modalDisplayDocumentDocumentBase64 = data['base64']
          this.loading?.dismiss()
      }, async error => {
        this.loading?.dismiss()
        var alert = await this.alertController.create({
          header: this.translate.instant("Error"),
          subHeader: this.translate.instant("Invalid file"),
          message: this.translate.instant("The PDF file is invalid or too large.") ,
          buttons: ['OK'],
        });
        await alert.present();
      });
    } else {
      if(document['base64']) {
        this.modalDisplayDocumentDocumentBase64 = document['base64']
      } else {
        this.modalDisplayDocumentDocumentBase64 = document['file']
      }
    }
  }

  getReportOfAnimal(event: AgendaEvent, animal: Animal): AgendaEventReport | null {
    for(let report of event.reports) {
      if(report.id && report.animal?.id == animal.id) {
        return report
      }
    }
    return null;
  }

  update() {
    this.router.navigate(['/event-update', this.event?.id]);
  }

  report() {
    this.router.navigate(['/event-report', this.event?.id]);
  }

  async enclose() {
    if(this.event == null)
      return

    if(this.event?.type?.isTreatment) {
      if (this.detectFastTreatment(this.event)) {
        this.event.treatmentIsSuccess = true;
        this.encloseExecute();
        return;
      }

      const alert = await this.alertController.create({
        header: this.translate.instant('End of treatment'),
        message: this.translate.instant('Is your pet\'s treatment complete? Is he feeling better?'),
        buttons: [ {
          text: this.translate.instant("The treatment is not complete"),
          handler: () => { } },
          {
            text: this.translate.instant("The treatment failed"),
            handler: async () => {
              if(this.event) {
                this.event.dateTimeEnd = this.dateUtils.toStringIso(new Date())
                this.event.treatmentIsSuccess = false;
                this.encloseExecute()
              }
            }
          },
          {
            text: this.translate.instant("The treatment is a success"),
            handler: async () => {
              if(this.event) {
                this.event.dateTimeEnd = this.dateUtils.toStringIso(new Date())
                this.event.treatmentIsSuccess = true;
                this.encloseExecute()
              }
            } 
          } ]
      });
      await alert.present();
    } else {
      this.encloseExecute()
    }
  }

  async encloseExecute() {
    if(this.event == null)
      return

    this.event.statut = this.agendaService.agendaEventStatuts.find(a => a.id == 'done') ?? null

    await this.presentLoading();
    this.agendaService.dbSaveEvent(this.event).then(async (data) => {
      this.stopLoading();
      if(this.event?.type?.isTreatment && this.event?.statut?.id == 'done' && this.event?.treatmentIsRecurring && !this.agendaService.events.find(a => a.createdFromEventId == this.event?.id)) {
        this.submitAskNextOccurence()
      } else {
        this.closeEvent.emit(this.event)
      }
    }).finally(() => {
      this.stopLoading();
    });
  }

  async submitAskNextOccurence() {
    let message = this.translate.instant('The treatment is recurring, do you want to automatically create an alert in the calendar for the next occurrence?');
    
    if (this.event?.eventRecurrentFast) {
      message = this.translate.instant('NEXT_OCCURRENCE_FAST_TREATMENT_MODAL', {
        treatmentName: this.event.treatmentName || this.event.comment
      });
    }

    this.nextOccurrenceMessage = message;
    this.nextOccurrenceDuration = this.event?.treatmentDuration ?? 0;
    this.nextOccurrenceUnit = this.event?.treatmentDurationUnit ?? 'Days';
    this.isNextOccurrenceModalOpen = true;
  }

  confirmNextOccurrence() {
    this.isNextOccurrenceModalOpen = false;
    let duration = Number(this.nextOccurrenceDuration);
    let unit = this.nextOccurrenceUnit;

    let event: AgendaEvent = Object.assign(new AgendaEvent(), this.event);
    event.id = null
    event.createdFromEventId = this.event?.id ?? null
    event.statut = this.agendaService.agendaEventStatuts.find(a => a.id == 'validated') ?? null
    
    let baseDate = this.dateUtils.fromString(this.event?.dateTimeStart ?? null) ?? new Date();

    if (unit == 'Days') {
      event.dateTimeEnd = this.dateUtils.toStringIso(addDays(baseDate, duration))
    } else if (unit == 'Weeks') {
      event.dateTimeEnd = this.dateUtils.toStringIso(addWeeks(baseDate, duration))
    } else if (unit == 'Months') {
      event.dateTimeEnd = this.dateUtils.toStringIso(addMonths(baseDate, duration))
    } else if (unit == 'Years') {
      event.dateTimeEnd = this.dateUtils.toStringIso(addYears(baseDate, duration))
    }
    event.dateTimeStart = event.dateTimeEnd
    event.treatmentDuration = duration;
    event.treatmentDurationUnit = unit;
    
    this.presentLoading();
    this.agendaService.dbSaveEvent(event).then(async (data: any) => {
      if(data['id']) {
          event.id = data['id']
          this.agendaService.events.push(event)
      }
      this.closeEvent.emit(this.event)
    }).finally(() => {
      this.stopLoading();
    });
  }

  cancelNextOccurrence() {
    this.isNextOccurrenceModalOpen = false;
    this.closeEvent.emit(this.event)
  }

  detectFastTreatment(event: AgendaEvent | null): boolean {
    if(!event) return false;
    if(event.eventRecurrentFast) return true;
    
    const ft = this.fastTreatments.find(ft => 
        event.treatmentIsRecurring && 
        (event.comment?.trim() == ft.defaultDescription?.trim() || event.comment?.trim() == ft.name?.trim())
    );
    if (ft) {
      if (!event.treatmentName) event.treatmentName = ft.name;
      return true;
    }
    return false;
  }

  async addToCalendar(event: any) {
    if (event) event.stopPropagation();
    if (!this.event) return;

    const title = (this.event.type?.name ?? this.translate.instant('Event')) + ' - ' + this.event.animals.map(a => a.name).join(', ');
    const description = this.event.comment ?? '';
    const start = this.dateUtils.fromString(this.event.dateTimeStart) ?? new Date();
    let end = this.dateUtils.fromString(this.event.dateTimeEnd);
    if (!end || end <= start) {
        end = new Date(start.getTime() + 3600000);
    }

    if (Capacitor.isNativePlatform()) {
      try {
        // Use CapacitorCalendar to open the native calendar UI
        // Note: For iOS, this usually doesn't require permissions for the prompt mode.
        // For Android, we might need write permission if it tries to write directly, 
        // but the prompt mode is generally handled by Intent.
        await CapacitorCalendar.createEventWithPrompt({
          title: title,
          description: description,
          startDate: start.getTime(),
          endDate: end.getTime(),
        });
      } catch (e) {
        console.error('Error adding to calendar via plugin', e);
        // Fallback to legacy ICS sharing if plugin fails
        this.addToCalendarICS(title, description, start, end);
      }
    } else {
        this.addToCalendarICS(title, description, start, end);
    }
  }

  async addToCalendarICS(title: string, description: string, start: Date, end: Date) {
    const formatICSDate = (date: Date) => {
      return date.toISOString().replace(/-|:|\.\d+/g, '').split('.')[0] + 'Z';
    };

    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      `DTSTART:${formatICSDate(start)}`,
      `DTEND:${formatICSDate(end)}`,
      `SUMMARY:${title}`,
      `DESCRIPTION:${description}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');

    if (Capacitor.isNativePlatform()) {
        const fileName = 'event.ics';
        const result = await Filesystem.writeFile({
          path: fileName,
          data: icsContent,
          encoding: 'utf8' as any,
          directory: Directory.Cache
        });

        // Use Share as second fallback if first one fails
        const shareModule = await import('@capacitor/share');
        const Share = shareModule.Share;
        await Share.share({
          title: title,
          url: result.uri,
        });
    } else {
        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'appointment.ics');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
  }
}
